import React, { useLayoutEffect, useRef } from 'react';

type UseStackShiftOptions = {
  itemKeys: string;
  itemRefs: React.MutableRefObject<
    Map<string, React.RefObject<HTMLDivElement>>
  >;
  enabled: boolean;
  duration: number;
  easing: string;
};

export const useStackShift = ({
  itemKeys,
  itemRefs,
  enabled,
  duration,
  easing,
}: UseStackShiftOptions) => {
  const offsets = useRef(new Map<string, number>());

  useLayoutEffect(() => {
    const shifts: Array<{ node: HTMLDivElement; deltaY: number }> = [];

    itemRefs.current.forEach((ref, key) => {
      const node = ref.current;

      if (!node) {
        itemRefs.current.delete(key);
        offsets.current.delete(key);
        return;
      }

      const previous = offsets.current.get(key);
      const current = node.offsetTop;

      offsets.current.set(key, current);

      if (
        previous === undefined ||
        !enabled ||
        typeof node.animate !== 'function'
      ) {
        return;
      }

      const deltaY = previous - current;

      if (deltaY) {
        shifts.push({ node, deltaY });
      }
    });

    shifts.forEach(({ node, deltaY }) => {
      node.animate(
        [
          { transform: `translateY(${deltaY}px)` },
          { transform: 'translateY(0)' },
        ],
        { duration, easing },
      );
    });
  }, [itemKeys, itemRefs, enabled, duration, easing]);
};
